var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-horizontal-menu',{staticClass:"selfservice-actions-menu",staticStyle:{"z-index":"8"},attrs:{"routes":_vm.tabRoutes,"hideOnScroll":"","isStickyOnMobile":_vm.sticky,"centered":_vm.centered,"extraHeight":""}})}
var staticRenderFns = []

export { render, staticRenderFns }